import { Truck } from 'lucide-react';
import type { ModuleDefinition } from '../../core/shared/types/index.js';

const logistiekManifest: ModuleDefinition = {
  id: 'logistiek',
  name: 'Logistiek',
  icon: <Truck size={20} />,
  color: 'var(--brand-primary)',
  basePath: '/logistiek',
  status: 'active',
  navItems: [
    { label: 'Dashboard', path: '/logistiek', icon: '📊' },
    { label: 'Pipeline', path: '/logistiek/pipeline', icon: '🗂️' },
    { label: 'Bestellingen', path: '/logistiek/bestellingen', icon: '🛒' },
    { label: 'Voorraad', path: '/logistiek/voorraad', icon: '📦' },
    { label: 'Leveringen', path: '/logistiek/leveringen', icon: '🚚' },
    { label: 'Vorderingsstaten', path: '/logistiek/vorderingsstaten', icon: '📋' },
    { label: 'Retouren', path: '/logistiek/retouren', icon: '↩️' },
    { label: 'Kosten', path: '/logistiek/kosten', icon: '💰' },
    { label: 'Leveranciers', path: '/logistiek/leveranciers', icon: '🏭' },
    { label: 'Partners', path: '/logistiek/partners', icon: '🤝' },
    { label: 'Schade', path: '/logistiek/schade', icon: '⚠️' },
    { label: 'Planning', path: '/logistiek/planning', icon: '📅' },
    { label: 'Financieel', path: '/logistiek/financieel', icon: '💹' },
    { label: 'Evaluaties', path: '/logistiek/evaluaties', icon: '⭐' },
    { label: 'Labels', path: '/logistiek/labels', icon: '🏷️' },
    { label: 'KPI', path: '/logistiek/kpi', icon: '📉' },
    { label: 'Rapportage', path: '/logistiek/rapportage', icon: '📈' },
    { label: 'Leverbonnen', path: '/logistiek/leverbonnen', icon: '📄' },
    { label: 'Nobilia Planning', path: '/logistiek/nobilia-planning', icon: '🏗️' },
    { label: 'Extra Stock', path: '/logistiek/extra-stock', icon: '📥' },
    { label: 'Winkel Voorraad', path: '/logistiek/winkel-voorraad', icon: '🏪' },
    { label: 'Document Scanner', path: '/logistiek/document-scan', icon: '📸' },
  ],
  component: () => import('./index.js'),
};

export default logistiekManifest;
